module.exports = __webpack_public_path__ + "img/IMG_7112.5af31291.webp";